// Order of import matters
import './_core_entry';
import renderComponents from '../client/initializers/renderComponents';
import renderHypernovaClient from '../hypernova/client';

// Initializing fns
import '../client/initializers';
renderHypernovaClient();
renderComponents();
